import { Button, Grid, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { FieldArray, useFormikContext } from "formik";
import { Fragment } from "react";
import Swal from "sweetalert2";
import {
  FileUploadInput,
  ReferenceDropDown,
  TextInput,
} from "../../../components";
import useLocales from "../../../hooks/useLocales";
import { changeFileName, checkFileSize, isExists } from "../../../utils";

export const GetDocumentsArray = () => {
  const { translate } = useLocales();
  const formik: any = useFormikContext();

  function alertHandler(index: number) {
    if (isExists(formik?.values?.documents[index]?.file?.fileName)) {
      Swal.fire(translate("resources.workOrders.file_updated"), "", "success");
    } else {
      Swal.fire(translate("resources.workOrders.file_uploaded"), "", "success");
    }
  }

  return (
    <FieldArray
      name="documents"
      render={(arrayHelpers) => (
        <>
          {formik.values?.documents?.length > 0 &&
            formik.values?.documents?.map((doc: any, index: any) => (
              <Fragment key={index}>
                <Grid item md={3}>
                  <ReferenceDropDown
                    name={`documents.${index}.documentFileId`}
                    label={translate("resources.workOrders.fileCategory")}
                    reference="fixity/customer/filecategory"
                    optionName="name"
                    placeholder={translate(
                      "resources.workOrders.choose_document_category"
                    )}
                    secondField={{
                      value: "name",
                      name: `documents.${index}.description`,
                    }}
                  />
                </Grid>
                <Grid item md={3}>
                  <TextInput
                    name={`documents.${index}.description`}
                    label={translate("resources.workOrders.description")}
                    placeholder={translate("resources.workOrders.description")}
                    disabled
                  />
                </Grid>
                <Grid item md={3}>
                  <FileUploadInput
                    name="document"
                    onChange={(event: any) => {
                      const file = event.target.files[0];

                      if (!checkFileSize(file)) {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: translate("actions.invalidFileSize"),
                        });
                        return null;
                      }

                      const fileReader = new FileReader();
                      fileReader.readAsDataURL(file);
                      fileReader.onload = (e: any) => {
                        alertHandler(index);
                        formik.setFieldValue(
                          `documents.${index}.file.base64`,
                          e.target.result.split(",")[1] ?? "",
                          false
                        );

                        const fileName = isExists(file.name)
                          ? changeFileName(file.name)
                          : "";

                        formik.setFieldValue(
                          `documents.${index}.file.fileName`,
                          fileName,
                          false
                        );
                        formik.setFieldValue(
                          `documents.${index}.file.contentType`,
                          file.type,
                          false
                        );
                        event.target.value = null;
                      };
                    }}
                  />
                  {!isExists(
                    formik.values?.documents[index]?.file?.fileName
                  ) ? (
                    <Typography
                      variant="body2"
                      style={{ color: "#d32f2f", fontSize: "0.75rem" }}
                    >
                      Lütfen Dosya yükleyiniz
                    </Typography>
                  ) : null}
                </Grid>
                <Grid item md={2}>
                  {formik.values?.documents[index]?.file?.fileName && (
                    <TextInput
                      name={`documents.${index}.file.fileName`}
                      label={translate("resources.workOrders.file_name")}
                      disabled
                    />
                  )}
                </Grid>
                {index > 0 && (
                  <Grid item md={1}>
                    <Button
                      variant="outlined"
                      color="error"
                      type="button"
                      fullWidth
                      sx={{ height: "50px" }}
                      onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                    >
                      {translate("actions.delete")}
                    </Button>
                  </Grid>
                )}
                {index === 0 &&
                  formik?.values?.documents[index]?.file?.fileName && (
                    <Grid item md={1}>
                      <Button
                        variant="outlined"
                        color="error"
                        type="button"
                        fullWidth
                        disabled={
                          !formik?.values?.documents[index]?.file?.fileName
                        }
                        sx={{ height: "50px" }}
                        onClick={() =>
                          arrayHelpers.replace(index, {
                            description: "",
                            documentCategoryId: 1,
                            file: {
                              base64: "",
                              fileName: "",
                              contentType: "",
                            },
                          })
                        }
                      >
                        {translate("resources.workOrders.remove")}
                      </Button>
                    </Grid>
                  )}

                <Grid item md={12}>
                  <Divider />
                </Grid>
                <Grid item md={12}>
                  <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={3}
                  >
                    {/* {index > 0 && index === formik.values.documents.length - 1 && (
                      <Grid item md={3}>
                        <Button
                          variant="outlined"
                          color="error"
                          type="button"
                          fullWidth
                          sx={{ height: "50px" }}
                          onClick={() => arrayHelpers.remove(index)} // remove a friend from the list
                        >
                          {translate("actions.delete")}
                        </Button>
                      </Grid>
                    )} */}
                    {index === formik?.values?.documents?.length - 1 && (
                      <Grid item md={3}>
                        <Button
                          variant="outlined"
                          color="primary"
                          type="button"
                          fullWidth
                          sx={{ height: "50px" }}
                          onClick={() =>
                            arrayHelpers.insert(
                              formik?.values?.documents?.length,
                              {
                                description: "",
                                documentCategoryId: 1,
                                file: {
                                  base64: "",
                                  fileName: "",
                                  contentType: "",
                                },
                              }
                            )
                          }
                        >
                          {translate("resources.workOrders.add_document")}
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </Fragment>
            ))}
        </>
      )}
    />
  );
};
